import React from 'react';
import { motion } from 'framer-motion';

const STAR_STYLE = { top: '50%', left: '50%' };

const STARS = Array.from({ length: 10 }, (_, i) => ({
  animate: {
    scale: [0, 1, 0],
    opacity: [0, 1, 0],
    x: [0, (Math.random() - 0.5) * 100],
    y: [0, (Math.random() - 0.5) * 100],
  },
  transition: { duration: 2, repeat: Infinity, delay: i * 0.2, ease: 'easeOut' },
}));

export const HeroStars = () =>
  STARS.map((cfg, i) => (
    <motion.div
      key={`star-${i}`}
      className="absolute w-2 h-2 bg-yellow-400 rounded-full"
      animate={cfg.animate}
      transition={cfg.transition}
      style={STAR_STYLE}
    />
  ));
